__turbopack_context__.v({
  "checkbox": "digestAlerts-module-scss-module__6jsAiW__checkbox",
  "dayWeek": "digestAlerts-module-scss-module__6jsAiW__dayWeek",
  "footer": "digestAlerts-module-scss-module__6jsAiW__footer",
  "inlineBlock": "digestAlerts-module-scss-module__6jsAiW__inlineBlock",
  "itemAlerts": "digestAlerts-module-scss-module__6jsAiW__itemAlerts",
  "selectDaysOfWeek": "digestAlerts-module-scss-module__6jsAiW__selectDaysOfWeek",
  "strong": "digestAlerts-module-scss-module__6jsAiW__strong",
  "timeSelect": "digestAlerts-module-scss-module__6jsAiW__timeSelect",
  "wrpSelect": "digestAlerts-module-scss-module__6jsAiW__wrpSelect",
});
